import React from 'react'
import {
  StatusClosedGrey,
  StatusDraftGrey,
  StatusOpenGrey
} from 'front-end/src/components/common/status/Status'

const SurveyStatus = ({
  isPublished,
  isCompleted
}: {
  isPublished: boolean
  isCompleted: boolean
}) => {
  return isCompleted ? (
    <StatusClosedGrey />
  ) : isPublished ? (
    <StatusOpenGrey />
  ) : (
    <StatusDraftGrey />
  )
}

export default SurveyStatus
